// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#component-lgpd .box-flutuante[data-v-9bb35644]{max-width:1140px;margin:0 auto;background:rgba(0,0,0,.7);color:#fff;padding:1em;position:fixed;z-index:5;bottom:-500px;left:calc(50% - 570px);display:flex;transition:all 2s;font-size:.875em}@media(max-width:767px){#component-lgpd .box-flutuante[data-v-9bb35644]{width:90%;left:5%;display:block}}#component-lgpd .exibir[data-v-9bb35644]{bottom:2em;transition:all 2s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
